




import {Component, Prop, Vue} from "vue-property-decorator";
import {ReceiptPaymentType} from "@/enums/type";

@Component({
  name: "ReceiptPaymentTypeLabel"
})
export default class extends Vue {
  @Prop({ type: Number, required: true }) readonly paymentType!: number;

  ReceiptPaymentType = ReceiptPaymentType;
}
